import { useEffect, useState } from "react";

// Barras horizontales livianas — div + porcentaje de ancho en vez de SVG,
// para que el responsive sea automático (a diferencia de un viewBox de SVG,
// un ancho en % se adapta solo al contenedor). Sin dependencias nuevas,
// consistente con el resto del design system artesanal del proyecto.
// Barras más gruesas + crecen de 0 al ancho final al montar (animación
// sutil de carga, sin tocar los datos).
export function GraficoBarras({
  datos,
  colorBarra = "bg-secundario",
}: {
  datos: { etiqueta: string; valor: number; color?: string }[];
  colorBarra?: string;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  if (datos.length === 0) {
    return <p className="text-sm text-texto-secundario">Sin datos para mostrar.</p>;
  }
  const maximo = Math.max(...datos.map((d) => d.valor), 1);
  return (
    <div className="space-y-4">
      {datos.map((d) => {
        const ancho = Math.max((d.valor / maximo) * 100, 3);
        return (
          <div key={d.etiqueta}>
            <div className="mb-1.5 flex items-center justify-between text-sm">
              <span className="font-medium text-texto">{d.etiqueta}</span>
              <span className="font-semibold text-texto-secundario">{d.valor}</span>
            </div>
            <div className="h-3 w-full overflow-hidden rounded-full bg-borde">
              <div
                className={`h-full rounded-full ${d.color ?? colorBarra} transition-all duration-700 ease-out`}
                style={{ width: visible ? `${ancho}%` : "0%" }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
